
import { Component, Vue, Prop} from 'vue-property-decorator';

import { packageInfoType } from '@/types/Information';

@Component({
    components:{        
    }
})
export default class SuccessSubmitManualForm extends Vue {

    @Prop({required: true})
    packageInfo!: packageInfoType;


    mountedData = false; 

    mounted() {
        this.mountedData = false;
        this.saveApplication(this.packageInfo);               
    }

    public saveApplication(newPackageInfo: packageInfoType) {

        const data = {
            packageNumber: newPackageInfo.packageNumber,
            packageUrl: newPackageInfo.eFilingUrl 
        } 

        const url = "/manual-submissions/efiling/"+newPackageInfo.fileNumber+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        this.$http.put(url, data, header)
        .then(res => {                            
            this.mountedData = true;
        }, err => {
            console.error(err);
            this.mountedData = true;
        });    
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
